import { lazy } from "react";
import { USERS } from "pages/routes/route.constant";
const user = lazy(() => import("pages/Users"));

export default {
  path: USERS,
  element: user,
};
